/* stylelint-disable no-descending-specificity */
import styled, { css } from 'styled-components'
import {
  TableComponents,
  Pill,
  FlatButton,
  Image,
  Flex,
  LinkUnstyled,
} from '@sketch/components'
import { ReactComponent as Lock } from '@sketch/icons/lock-closed-17'
import { ReactComponent as Link } from '@sketch/icons/markdown-link-share-17'
import { ReactComponent as Sliders } from '@sketch/icons/sliders-3-17'
import { ReactComponent as Arrow } from '@sketch/icons/arrow-right-circle-semifilled-17'

export const TableCell = styled(TableComponents.TableCell)`
  vertical-align: top;
  padding: 8px 8px 8px 20px;
`

export const TableRow = styled(TableComponents.TableRow)`
  vertical-align: top;

  ${/* sc-selector */ TableCell}:first-child {
    width: 260px;
  }
`

export const DocumentPreviewsLayoutWrapper = styled.div`
  margin: 0 0 16px;
  position: relative;

  ${TableComponents.Table} {
    min-width: 640px;
  }
`

export const DocumentDetails = styled(LinkUnstyled)`
  display: flex;
  align-items: center;
  min-height: 48px;
  width: fit-content;
  max-width: 260px;
  white-space: wrap;
`

export const DocumentThumbnail = styled(Image)(
  ({ theme }) => css`
    width: 32px;
    height: 32px;
    margin-right: 12px;
    border: 1px solid ${theme.colors.border.A};
    border-radius: ${theme.radii.medium};
    overflow: hidden;
    flex-shrink: 0;
  `
)

export const DocumentName = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.foreground.secondary.A};
    font-weight: ${theme.fontWeights.medium};
    font-size: ${theme.fontSizes.E};
  `
)

const iconStyles = css`
  width: 17px;
  height: 17px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const ArrowIcon = styled(Arrow)`
  ${iconStyles};
`

export const SlidersIcon = styled(Sliders)`
  ${iconStyles};
  margin-right: 24px;
`

export const LinkIcon = styled(Link)`
  ${iconStyles};
  margin-right: 24px;
`

export const LockIcon = styled(Lock)`
  ${iconStyles};
`

export const Actions = styled(Flex)`
  gap: 24px;
  height: 48px;
  align-items: center;

  > div {
    height: 17px;
  }
`

export const ActionButton = styled(FlatButton)`
  ${iconStyles};
  padding: 0;
`

export const PreviewOverview = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 0;
  column-gap: 4px;

  ${Pill} {
    margin-left: 4px;
  }
`
